import React, {useState} from "react"
import './tickets.scss';

import tickets from '../../assets/tickets.png';
import badge from '../../assets/badgeT.jpg';
import mug from '../../assets/mugT.jpg';
import mugL from '../../assets/mugLeftiesT.jpg';
import mugAll from '../../assets/mugAllT.jpg';
import fanhunter from '../../assets/fanhunter.jpg';

function Tickets() {

    const [agotado, setAgotado] = useState(false);

    const clickTickets = () => {
        console.log('aa LICKS!');
        setAgotado(true);
    }

    const buttonClass = (agotado) => {
        const text = agotado? 'Agotado' : 'Comprar';
        const buttonClass = agotado ? 'agotado': '';
        return(
            <button className={buttonClass}>{text}</button>
        );
    }
    
    const agotadoStyle = agotado ? {display: 'block'} : {display: 'none'};
    const buttonStyle = agotado ? {pointerEvents: 'none'} : {};

    return (
        <section id="entradas" className="scroller">
            <h3>Entradas</h3>
            <div className="background">
                <article>
                    <p>
                        Si lo que quieres es disfrutar al 100% del parque, lo que te recomendamos sin duda es que pases varios días para poder disfrutar sin prisas. Para ello puedes alojarte en una de nuestras maravillosas estancias en Teide d'Or Ciudad de Vacaciones. ¡No hay un lugar mejor!
                    </p>
                    <button onClick={clickTickets} style={buttonStyle} className="ticket-button">
                        <img className="entradas-image" src={tickets} alt='entradas al parque'/>
                        Comprar
                        <p className="entradas-agotado" style={agotadoStyle}>
                            Agotado
                        </p>
                    </button>
                </article>
            </div>
            <div className="background">
                <article>
                    <p>
                        ¡Completa tu aventura! Añade los siguientes extras a tu visita.
                    </p>
                    <ul>
                        <li className="product product-disabled">
                            <img src={badge} alt='Triassik park badge'/>
                            <p>Chapa metálica Triassic Park</p>
                            {buttonClass(true)}
                        </li>
                        <li className="product product-disabled">
                            <img src={mug} alt='Triassik park mug'/>
                            <p>Taza Triassic Park</p>
                            {(buttonClass(true))}
                        </li>
                        <li className="product product-disabled">
                            <img src={mugL} alt='Triassik park lefties mug'/>
                            <p>Taza Triassic Park zurdos</p>
                            {(buttonClass(true))}
                        </li>
                        <li className="product product-disabled">
                            <img src={mugAll} alt='Triassik park lefties mug'/>
                            <p>Taza Triassic Park familiar</p>
                            {(buttonClass(true))}
                        </li>
                        <li className="product product-disabled">
                            <img src={fanhunter} height={300} alt='Triassik park mug'/>
                            <p>Fanhunter: El Juego de Rol</p>
                            <a href="https://devir.es/fanhunter" target="blank">{buttonClass(false)}</a>
                        </li>
                    </ul>
                </article>
            </div>
        </section>
    );
}

export default Tickets;
